import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
// Wave 1 design system: tokens -> primitives -> shell (after Bootstrap so
// token-driven base rules win on equal specificity).
import "./styles/tokens.css";
import "./styles/ui.css";
import "./styles/global.css"; // F3 legacy layer — progressively retired by later waves
import { FeedbackProvider } from "./components/ui/feedback";

const enableServiceWorker = false;

// Remove registrations from older deployments so stale bundles/configuration
// cannot keep directing clients to a previous LAN address.
if (!enableServiceWorker && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}

if (enableServiceWorker && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration.scope);
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <FeedbackProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </FeedbackProvider>
  </React.StrictMode>
);

reportWebVitals();
